import { Group, Switch, type SwitchProps } from "@mantine/core";
import classNames from "classnames";
import type { CommonFormFieldItemProps } from "../FormField";
import { FormFieldLabel } from "../FormFieldLabel";
import { FormFieldRightSection } from "../FormFieldRightSection";

interface FormFieldSwitchProps
  extends
    CommonFormFieldItemProps,
    Omit<SwitchProps, "value" | "defaultValue" | "checked" | "defaultChecked"> {
  type: "switch";
  value?: boolean;
  defaultValue?: boolean;
}

function FormFieldSwitch({
  helpText,
  highlight,
  isBetaFeature,
  type,
  warned,
  value,
  defaultValue,
  ...fieldSpecificProps
}: FormFieldSwitchProps) {
  return (
    <Group align="center">
      <Switch
        {...fieldSpecificProps}
        aria-label={
          typeof fieldSpecificProps.label === "string"
            ? fieldSpecificProps.label
            : undefined
        }
        checked={value ?? false}
        className={classNames("FormFieldSwitch", fieldSpecificProps.className)}
        defaultChecked={defaultValue}
        label={undefined}
      />
      <Group align="center" flex={1} justify="space-between">
        {fieldSpecificProps.label && (
          <FormFieldLabel
            flex={1}
            helpText={helpText}
            highlight={highlight}
            isBetaFeature={isBetaFeature}
            label={fieldSpecificProps.label}
            mb={0}
            required={fieldSpecificProps.required}
          />
        )}
        <FormFieldRightSection warned={warned} />
      </Group>
    </Group>
  );
}

export { FormFieldSwitch, FormFieldSwitchProps };
